import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initComponents, initLayouts } from './components'
import { initDirectives } from './directives'
import { initValidations } from './validation'

import Notifications from '@kyvg/vue3-notification'

import { alertBox, fileUploadBox, imageBox, layoutSystem, modalBox } from '@ezio/ui'

import * as Sentry from '@sentry/vue'

import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import { useEzioAPI, useEzioNodeAPI } from '@ezio/services'
import { useEzioWs } from '@ezio/services'
import { reset, useTokensStore } from './stores'
import { createPinia } from 'pinia'
import { useRoute } from 'vue-router'

console.warn(import.meta.env.APP_NAME, import.meta.env.APP_VERSION)

const app = createApp(App)
app.use(createPinia())

const { api } = useEzioAPI()
api.tokensStore = useTokensStore()
api.onLoggingOut(() => {
    reset()
    const route = useRoute()
    if (route?.meta?.requireAuth) {
        router.push('/sign-in')
    }
})

const { ws } = useEzioWs()
ws.setTokensStore(useTokensStore())

app.use(router)

app.use(alertBox)
app.use(imageBox)
app.use(fileUploadBox)
app.use(modalBox)

app.use(Notifications)

app.use(layoutSystem, {
    defaultLayout: 'Main'
})

if (import.meta.env.MODE === 'production') {
    Sentry.init({
        app,
        dsn: 'https://275ea14c9b7c45d36236a855ba926dcc@o99640.ingest.sentry.io/4506780796059648',
        environment: 'production',
        release: import.meta.env.APP_VERSION,
        integrations: [
            Sentry.httpClientIntegration(),
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false
            })
        ],

        // This option is required for capturing headers and cookies.
        sendDefaultPii: true,
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', /^https:\/\/api\.ezio\.app/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
}

initComponents(app)
initDirectives(app)
initLayouts(app)
initValidations()
dayjs.locale('fr')

app.mount('#app')

export default app
